"use strict";

require("core-js/modules/es6.array.filter.js");

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");

var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");

var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");

var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");

var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Typography = _interopRequireDefault(require("../Typography"));

var _style = require("./style");

var _localeConsumerDecorator = require("../../utils/localeConsumerDecorator");

var _zh_CN = _interopRequireDefault(require("./locale/zh_CN"));

var _excluded = ["value", "size", "styleType", "unit", "locale"];

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Text = _Typography["default"].Text;
/**
 * ChargeInfo.Price
 * @description 计费UI组件-表单项价格
 */

var Price = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Price, _Component);

  var _super = _createSuper(Price);

  function Price() {
    (0, _classCallCheck2["default"])(this, Price);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(Price, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          value = _this$props.value,
          size = _this$props.size,
          styleType = _this$props.styleType,
          unit = _this$props.unit,
          locale = _this$props.locale,
          others = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      var sizeMap = {
        lg: {
          size: "t6",
          lineHeight: "sm"
        },
        md: {
          size: "t3",
          lineHeight: "md"
        },
        sm: {
          size: "t2",
          lineHeight: "md"
        },
        xs: {
          size: "t1",
          lineHeight: "lg"
        }
      };
      var styleTypeMap = {
        normal: {
          color: "dark"
        },
        total: {
          color: "primary"
        },
        refund: {
          color: "light"
        },
        "total-refund": {
          color: "success"
        }
      };

      var refundTag = /*#__PURE__*/_react["default"].createElement(_style.StyledPriceRefundTag, (0, _extends2["default"])({}, sizeMap[size], {
        color: "success"
      }), "\u300C", locale.refund, "\u300D");

      return /*#__PURE__*/_react["default"].createElement(_style.StyledPriceWrapper, (0, _extends2["default"])({
        unit: unit,
        size: size
      }, others), styleType === "refund" && refundTag, value || value === 0 ? /*#__PURE__*/_react["default"].createElement(Text, (0, _extends2["default"])({}, _objectSpread(_objectSpread({}, sizeMap[size]), styleTypeMap[styleType]), {
        strong: true,
        className: "".concat(_style.prefixCls, "-price-wrapper-inner")
      }), value) : /*#__PURE__*/_react["default"].createElement(Text, (0, _extends2["default"])({}, sizeMap[size], {
        strong: true,
        className: "".concat(_style.prefixCls, "-price-wrapper-inner"),
        color: "remark"
      }), "-"), /*#__PURE__*/_react["default"].createElement(Text, {
        color: "light",
        size: "t1",
        lineHeight: "lg",
        transform: "uppercase"
      }, unit));
    }
  }]);
  return Price;
}(_react.Component);

(0, _defineProperty2["default"])(Price, "propTypes", {
  /** 表单项价格的值 */
  value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

  /** 表单项价格的尺寸 */
  size: _propTypes["default"].oneOf(["xs", "sm", "md", "lg"]),

  /** 表单项价格的样式类型 */
  styleType: _propTypes["default"].oneOf(["normal", "total", "refund", "total-refund"]),

  /** 表单项价格的单位 */
  unit: _propTypes["default"].string,

  /** @ignore */
  locale: _propTypes["default"].object
});
(0, _defineProperty2["default"])(Price, "defaultProps", {
  size: "md",
  styleType: "normal",
  unit: ""
});

var _default = (0, _localeConsumerDecorator.localeConsumerDecorator)({
  defaultLocale: _zh_CN["default"],
  localeName: "UI_ChargeInfo"
})(Price);

exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ui-components/lib/components/ChargeInfo/Price.js
// module id = 2080
// module chunks = 6 7 17 18